
import logger from '../logger'
import extendedObservable from './base'
import api from '../api'


// ////////////////
// Authentication //
// ////////////////

export function Authentication() {
  extendedObservable(this, 'authenticationModel')

  const successHandler = (json) => {
    logger('Success: Communicated with OP Authentication Service - ', 'info')()
    logger(json, 'info')()

    this.model = json

    return this.model
  }

  // register and unregister event listeners
  this.on('registerAuthenticationObserver', observer => this.registerObserver(observer))
  this.on('unregisterAuthenticationObserver', observer => this.unregisterObserver(observer))

  this.on('authByEmail', (data, cb, ecb) => {
    logger('postAuthentication', 'debug')()
    api.authentication.post(data)
      .then(successHandler)
      .then(this.notifyObservers)
      .then(cb)
      .fail(ecb)
  })
}
